import { ok } from '../../../base/common/assert.js';
import { isString, isObject } from '../../../base/common/types.js';
class RegistryImpl {
    constructor() {
        this.data = ( new Map());
    }
    add(id, data) {
        ok(isString(id));
        ok(isObject(data));
        ok(!( this.data.has(id)), 'There is already an extension with this id');
        this.data.set(id, data);
    }
    knows(id) {
        return ( this.data.has(id));
    }
    as(id) {
        return this.data.get(id) || null;
    }
}
const Registry = ( new RegistryImpl());
export { Registry };
